import { AlertCircle } from "lucide-react";
import React, { useState } from "react";
import {
  Alert,
  Space,
  Text,
  TextInput,
  Button,
  Modal,
  Group,
} from "@mantine/core";

type ConfirmDeleteModelProps = {
  onConfirm: () => void;
  onClose: () => void;
  opened: boolean;
  isLoading: boolean;
  label: string;
};

const ConfirmDeleteModel: React.FC<ConfirmDeleteModelProps> = ({
  onConfirm,
  label,
  opened,
  onClose,
  isLoading,
}) => {
  const [confirm, setConfirm] = useState("");

  return (
    <Modal
      opened={opened}
      size="md"
      onClose={() => onClose()}
      title={`Delete ${label}?`}
      centered
      overlayOpacity={0.1}
      overlayBlur={3}
    >
      {/* eslint-disable-next-line react/jsx-no-undef */}
      <Alert icon={<AlertCircle size={16} />} color="yellow" radius="md">
        <span className="font-bold text-yellow-600">Warning! </span>
        <span>This action cannot be undone!</span>
      </Alert>
      <Space h="xl" />

      <Text size="md">{`Are you sure you want to delete your ${label}?`}</Text>
      <Space h="xl" />

      <TextInput
        label={
          <span className="text-sm font-bold">Type DELETE to confirm</span>
        }
        placeholder="DELETE"
        onChange={({ target }) => setConfirm(target.value)}
      />

      <Space h="xl" />

      <Group spacing="xl" position="apart">
        <Button onClick={() => onClose} variant="default">
          No don&apos;t delete it
        </Button>
        <Button
          type="button"
          onClick={() => onConfirm()}
          variant="filled"
          color="red"
          loading={isLoading}
          disabled={!Object.is(confirm, "DELETE")}
        >
          {`Delete ${label}`}
        </Button>
      </Group>
    </Modal>
  );
};

export default ConfirmDeleteModel;
